'use client';

import { cx, css } from 'styled-system/css';
import { BetDefaultStakeType } from '@/services/account.service';
import { StakeKeypad } from '../stake-keypad';
import { StakeInput } from '../stake-input';
import { useDefaultStake } from './use-default-stake';
import { galaxyDefaultStakeStyle } from './galaxy-default-stake.style';
import clsx from 'clsx';

// 使用部分
// galaxy : me page

export const GalaxyDefaultStake = () => {
	const {
		defaultStakeList,
		selectedId,
		changeSelectedId,
		inputStake,
		isInputFocus,
		toggleInput,
		isInputSelected,
		setSelectKey,
		onNumberPress,
		onBackspacePress,
		saveCustomize,
		setInputStake
	} = useDefaultStake('me');

	return (
		<>
			{defaultStakeList?.map(item => {
				const isActive = selectedId === item.id;
				return (
					<div
						key={item.id}
					>
						<div
							className={clsx('settings__list-btn')}
							onClick={changeSelectedId(item.id)}
							data-selected={isActive}
						>
							<div>{item.text}</div>
						</div>

						{item.id === BetDefaultStakeType.Customize ? (
							<div className={clsx(
								css({ display: isActive ? 'block' : 'none' }),
								galaxyDefaultStakeStyle.stakeInput
							)}
							>
								<StakeInput
									inputValue={inputStake}
									setInputValue={(input: number) => setInputStake(input)}
									isFocus={isInputFocus}
									setFocusKey={toggleInput}
									isSelect={isInputSelected}
									setSelectKey={setSelectKey}
								/>
								<StakeKeypad
									isOpen={isInputFocus}
									onNumberPress={onNumberPress}
									onBackspacePress={onBackspacePress}
									clickDone={saveCustomize}
								/>
							</div>
						) : null}
					</div>
				)
			})}
		</>
	)
}